// src/js/widgets/manager-requests/composables/useUserRole.ts

import { ref, onMounted } from 'vue';
import type { ManagerRole, ApiRequestType } from '../types';
import { getApiUrl } from '@/js/utils/getApiUrl';
import { roleToType } from '../types';

function isManagerRole(value: string): value is ManagerRole {
  return ['managerr', 'managera', 'managerp'].includes(value as ManagerRole);
}

export function useUserRole() {
  const role = ref<ManagerRole | null>(null);
  const apiType = ref<ApiRequestType | null>(null);
  const loading = ref(true);
  const error = ref<string | null>(null);

  const loadRole = async () => {
    try {
      const url = getApiUrl('/api/getUserRole.php');
      const response = await fetch(url);

      const result = await response.json();

      if (!result || typeof result !== 'object' || !('success' in result)) {
        throw new Error('Некорректный формат ответа от сервера');
      }

      if (!result.success) {
        throw new Error(result.msg || 'Ошибка авторизации');
      }

      const rawRole = result.msg;

      if (typeof rawRole !== 'string') {
        throw new Error('Роль должна быть строкой');
      }

      const trimmedRole = rawRole.trim();

      if (!isManagerRole(trimmedRole)) {
        throw new Error('Недопустимая роль пользователя');
      }

      role.value = trimmedRole;
      apiType.value = roleToType[role.value];
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Ошибка загрузки роли';
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    loadRole();
  });

  return { role, apiType, loading, error };
}
